<div class="header accredible-content">
  <a [href]="homeUrl">
    <img
      src="/assets/images/directory-of-directories/accredible_directory_network_logo.svg"
      alt="" />
  </a>
</div>
